<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Payroll Configuration Questionnaire</h1>
    <p>To get to know your payroll we'd like to understand how your organisation manages specific payroll rules and calculations.</p>
    <p>The information you provide ensures that your payroll setup accurately reflects your company’s policies.</p>

  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>